/**
 * Allys Property Features Component
 * 
 * Allys-themed wrapper for PropertyFeatures - clean styling
 */

'use client';

import { PropertyFeatures, type PropertyFeaturesProps } from '@/components/properties';

export function AllysPropertyFeatures(props: PropertyFeaturesProps) {
  return (
    <div 
      className="relative font-inter"
    >
      <PropertyFeatures {...props} className="" />
    </div>
  );
}
